export enum DownloadFiltersTypeEnum {
  MODEL = "MODEL",
  ASSET = "ASSET",
  CURRICULUM="CURRICULUM",
  CLASS="CLASS",
  BUNDLE="BUNDLE"
}